import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getSystemParameters, updateSystemParameter } from '../api/systemParameterApi'
import type { PagedResponse, SystemParameter, SystemParameterUpdate } from '../types'

const KEY = 'admin-system-parameters'

/** Sistem parametresi sunucu-durumu: liste + değer güncelleme. */
export function useSystemParameters(q: string) {
  const qc = useQueryClient()
  const list = useQuery({ queryKey: [KEY, q], queryFn: () => getSystemParameters(q) })

  const update = useMutation({
    mutationFn: ({ id, body }: { id: number; body: SystemParameterUpdate }) =>
      updateSystemParameter(id, body),
    onSuccess: (data) => {
      qc.setQueryData<PagedResponse<SystemParameter>>([KEY, q], (prev) =>
        prev
          ? { ...prev, content: prev.content.map((p) => (p.id === data.id ? data : p)) }
          : prev,
      )
      qc.invalidateQueries({ queryKey: [KEY] })
    },
  })

  return { list, update }
}
